import { jsx as m } from "react/jsx-runtime";
import { c as a } from "react/compiler-runtime";
import { MapProvider as p } from "./MapContext.js";
import f from "./MapInitializer.js";
import { memo as u } from "react";
import { isEqual as h } from "lodash";
import '../../../assets/index.css';const w = (e) => {
  const t = a(13);
  let o, i, s;
  t[0] !== e ? ({
    width: i,
    height: s,
    ...o
  } = e, t[0] = e, t[1] = o, t[2] = i, t[3] = s) : (o = t[1], i = t[2], s = t[3]);
  const c = i === void 0 ? "400px" : i, r = s === void 0 ? "400px" : s, d = o.showAddressInput ?? !0;
  let n;
  t[4] !== r || t[5] !== o.children || t[6] !== o.options || t[7] !== d || t[8] !== c ? (n = /* @__PURE__ */ m(f, { width: c, height: r, showAddressInput: d, options: o.options, children: o.children }), t[4] = r, t[5] = o.children, t[6] = o.options, t[7] = d, t[8] = c, t[9] = n) : n = t[9];
  let l;
  return t[10] !== o || t[11] !== n ? (l = /* @__PURE__ */ m(p, { ...o, children: n }), t[10] = o, t[11] = n, t[12] = l) : l = t[12], l;
}, j = u(w, (e, t) => {
  const o = h(e.markers, t.markers), i = h(e.circles, t.circles), s = h(e.options, t.options), c = e.showAddressInput === t.showAddressInput, r = e.children === t.children, d = h(e.center, t.center);
  return o && i && s && c && r && d;
});
export {
  j as default
};
